import backend from "apps/shared/backend";

export default function(form_identifier, feedbackUrl) {
  const formContainer = document.getElementById(form_identifier);
  const form = formContainer.querySelector("form");

  function showErrors(errors=null) {
    const container = form.querySelector('.feedback-form__errors');
    container.innerHTML = ''; // remove all existing children
    let child = null;
    
    if (errors && errors.length > 0) {
      for (let error of errors) {
        child = document.createElement('div');
        child.innerHTML = error;
        container.appendChild(child);
      }
    } else {
      container.innerHTML = "Ein unbekannter Fehler ist aufgetreten!";
    }

    // reset google captcha
    if(window.grecaptcha) {
      grecaptcha.reset();
    }
  }

  async function sendFeedback() {
    const formData = new FormData(form);

    try {
      // The last two arguments to backend:
      // undefined in order to set extraOptions parameter to default value
      // null in order to explicitely delete contentType
      // this ensures that the default contentType "application/json" is not used
      // instead, the correct contentType is set automatically by Axios based on the formData object
      const data = await backend(feedbackUrl, "POST", formData, undefined, null);
      if (data && data.data && data.data.success) {
        formContainer.innerHTML = "<br/><h1>Danke</h1><p>Wir haben Ihr Anliegen erhalten!</p>";
      } else {
        showErrors(data?.data?.errors);
      }
    } catch (e) {
      console.error(e);
      showErrors();
    }
  }

  form.addEventListener("submit", event => {
    event.preventDefault();
    sendFeedback();
  })
}
